import { createApiAction } from '@saucelabs/sl-util-redux';

import { getTimeFilterParams, getPaginationParams } from './../../api-adapter';
import * as api from './api';
import * as constants from './types';

// get test names
export const getFailureTests = createApiAction(
  constants.GET_FAILURE_TESTS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...getPaginationParams(analytics.failureAnalysis.get('pagination')),
    };

    return api.getFailureTests(params);
  },
);
